import { create } from 'zustand';

interface State {
  online: boolean;
  liveServerOnline: boolean;
  tick: NodeJS.Timeout | null;
  setStatus: (status: boolean) => void;
  setLiveServerStatus: (status: boolean) => void;
}

/*
  This store is used to trigger changes in the ui based on a connection status (e.g opening a recconnection modal).
  The connection status is handled by the application itself.
*/

export const useNetworkStore = create<State>((set, get) => ({
  online: true, // assume connected before initialization,
  liveServerOnline: true,
  tick: null, // will check every 250 seconds for a reconnection when offline

  setStatus: (status: boolean): void => {
    if (status === get().online) {
      return;
    }

    if (!status) {
      set({
        tick: setInterval(() => {
          if (navigator.onLine) {
            get().setStatus(true);
          }
        }, 250),
      });
    } else {
      const tick = get().tick;
      if (tick) {
        clearInterval(tick);
        set({ tick: null });
      }
    }

    set({ online: status });
  },
  setLiveServerStatus: (status: boolean): void => {
    set({ liveServerOnline: status });
  },
}));

export const networkStoreSelector = {
  online: (state: State): State['online'] => state.online,
  liveServerOnline: (state: State): State['liveServerOnline'] =>
    state.liveServerOnline,
  isAllConnected: (state: State): boolean =>
    state.online && state.liveServerOnline,
};
